/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowBoldUp: {
  name: 'arrow-bold-up';
  data: string;
} = {
  name: 'arrow-bold-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2a1 1 0 0 1 .8.4l6 8A1 1 0 0 1 18 12h-2v8a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8H6a1 1 0 0 1-.8-1.6l6-8A1 1 0 0 1 12 2Zm-4 8h1a1 1 0 0 1 1 1v9h4v-9a1 1 0 0 1 1-1h1l-4-5.333L8 10Z" fill="currentColor"/></svg>`,
};
